import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import Usuarios from './Usuarios';
import DeleteIcon from '@material-ui/icons/Delete';
import { keys } from '@material-ui/core/styles/createBreakpoints';
import Unidadetransporte from '../componentes/unidadetransporte1';
import Tooltip from '@material-ui/core/Tooltip';
import TipoVeiculo from '../componentes/componetetipoveiculo';
import Veiculo from '../componentes/componenteveiculos';
import Motoristascategoria from '../componentes/componentemotoristascategoria';



const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
 
  
  avatar: {
    backgroundColor: red[500],
  },
}));


     

    
  
  
export default function RecipeReviewCard(props) {
  console.log(props);
  console.log(props);
  const [statecampi,setstatecampi]=React.useState("Campus Santa Maria");
  const [tipoveiculo,setatveiculo]=React.useState([{
    id:''
  }]);
  const [veic,setaveic]=React.useState("");
  
  var setaveicmotora=[];
  var valorescategoriamotorista;

   const setamotora = (prop)=>{
    console.log('aqui esta chegando o tipo catmoto', prop);
    //console.log('aqui esta chegando o tipo catmoto', props.categoriamotorista.value);
    var catmotora =  prop.categoriamotorista.value;
    firebase.firestore().collection("categoriasmotorista").doc(catmotora).get()
    .then((doc) => {
      if (doc.exists) {
     // console.log('aqui esta chegando o tipo catmoto', prop.categoriamotorista.value);
        valorescategoriamotorista=[];
       
          valorescategoriamotorista.push({id: doc.id, catmotorista: doc.data().catmotorista, valorhora50: doc.data().valorhora50,valorhora100: doc.data().valorhora100,
            valoralmoco:doc.data().valoralmoco, valorjantar: doc.data().valorjanta, valorcafe: doc.data().valorcafe,
            valoradicionalnoturno: doc.data().valoradicionalnoturno, valorpernoite: doc.data().valorpernoite, valorbanho:doc.data().valorbanho, valorespera:doc.data().valorespera,
            valorsobreaviso:doc.data().valorsobreaviso,
        });
        
        console.log("listass valores catmotora: ", valorescategoriamotorista);
        setaveicmotora.push({motorista: prop, veiculo: veic});
    console.log('aqui esta chegando o tipo', prop);
    console.log('aqui esta chegando o tipo', veic);
    console.log('aqui esta chegando o tipo', tipoveiculo);
    props.setavalorescategoriamotorista(valorescategoriamotorista);
    props.setavaloretipoveiculo(tipoveiculo);
    props.setaveiculomotora(setaveicmotora);
      }else{
        alert('Não foissível carregar os valores para calcular as despesas do motorista.');
      } 
    })
    .catch(function(error) {
        console.log("erro carregar as unidades de tipos veiculos: ", error);
        alert('Erro carregar os valores para calcular as despesas do motorista.');
    });

    
  }

  const setaveiculo=(props)=>{
    setaveic(props);
    console.log('aqui esta chegando o tipo', props);


  }
  
  const setatipoveiculo=(props)=>{
    setatveiculo(props);
    console.log('aqui esta chegando o tipo', props[0]);
    console.log('aqui esta chegando o tipo', props[0].listacatmotoras);


  }
  
  const classes = useStyles();
  
  
  return (
    <div>
                        
          <div id="undmotora" className={classes.root} >
          <TipoVeiculo requer={true} id={"listatiposv"} 
          cod={''} props={tipoveiculo} setatipoveiculo={setatipoveiculo} />
                
              <br>{console.log("br")}</br>
              <Veiculo requer={true} id={"listav"} retorno={props.setatemporetorno} saida={props.datahorasaidareal}
          codtipoveiculo={tipoveiculo[0].id} codunidadetransporte={props.codunidadetransporte} setaveiculo={setaveiculo} />
          
          <br>{console.log("br")}</br>
              <Motoristascategoria requer={true} id={"listamotora"} retorno={props.setatemporetorno} saida={props.datahorasaidareal}
          codsmotora={tipoveiculo[0].listacatmotoras} codunidadetransporte={props.codunidadetransporte} setamotora={setamotora} />
          
          </div>
          
                    

            </div>
  );
}